var map = {
	"./bnt_1.png": "fca5",
	"./btn_2.png": "4c8c",
	"./icon_email.png": "b5c3",
	"./icon_site.png": "f6f8",
	"./inco_phone.png": "5832",
	"./mytask_1.jpg": "532c",
	"./mytask_2.jpg": "2239",
	"./platforminfo.png": "b715",
	"./platforminfo_1.png": "8306",
	"./platforminfo_2.png": "e75e",
	"./platforminfo_3.png": "bf5f",
	"./platforminfo_4.png": "55fb",
	"./project_1.jpg": "5dd1",
	"./project_10.jpg": "0b81",
	"./project_11.jpg": "a5e5",
	"./project_12.jpg": "af25",
	"./project_13.jpg": "6737",
	"./project_14.jpg": "f79b",
	"./project_15.jpg": "a881",
	"./project_16.jpg": "f664",
	"./project_17.jpg": "b533",
	"./project_18.jpg": "2108",
	"./project_19.jpg": "8ecb",
	"./project_2.jpg": "488b",
	"./project_20.jpg": "f1b2",
	"./project_21.jpg": "8049",
	"./project_3.jpg": "b7c8",
	"./project_4.jpg": "4ab3",
	"./project_5.jpg": "20a0",
	"./project_6.jpg": "1ee5",
	"./project_7.jpg": "f19e",
	"./project_8.jpg": "2f61",
	"./project_9.jpg": "13dd",
	"./registerlogin.png": "424f",
	"./registerlogin_1.jpg": "5d20",
	"./registerlogin_2.jpg": "c9af",
	"./registerlogin_3.jpg": "6492",
	"./registerlogin_4.jpg": "2df7",
	"./registerlogin_5.jpg": "9465",
	"./registerlogin_6.jpg": "7373",
	"./registerlogin_7.jpg": "05af",
	"./teachingmanagement_1.jpg": "430d",
	"./teachingmanagement_2.jpg": "a0ff3",
	"./teachingmanagement_3.jpg": "4a41",
	"./teachingmanagement_4.jpg": "9e5c",
	"./teachingmanagement_5.jpg": "8878",
	"./teachingmanagement_6.jpg": "dc9a",
	"./teammanagement_1.jpg": "5672",
	"./teammanagement_2.jpg": "52cb",
	"./translationeditor_1.jpg": "cbc4",
	"./translationeditor_10.jpg": "9f61",
	"./translationeditor_11.jpg": "7c5d",
	"./translationeditor_12.jpg": "8a76",
	"./translationeditor_13.jpg": "8635",
	"./translationeditor_14.jpg": "066a",
	"./translationeditor_15.jpg": "d9da",
	"./translationeditor_16.jpg": "34aa",
	"./translationeditor_17.jpg": "bbb7",
	"./translationeditor_18.jpg": "8b99",
	"./translationeditor_19.jpg": "517a",
	"./translationeditor_2.jpg": "d4ff",
	"./translationeditor_20.jpg": "9402",
	"./translationeditor_21.jpg": "b8c7",
	"./translationeditor_22.jpg": "cbc5",
	"./translationeditor_23.jpg": "cd0e",
	"./translationeditor_24.jpg": "4cf1",
	"./translationeditor_25.jpg": "124f",
	"./translationeditor_3.jpg": "3b93",
	"./translationeditor_4.jpg": "34d6",
	"./translationeditor_5.jpg": "1b85",
	"./translationeditor_6.jpg": "6256",
	"./translationeditor_7.jpg": "ee80",
	"./translationeditor_8.jpg": "2dc8",
	"./translationeditor_9.jpg": "741d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	var module = __webpack_require__(id);
	return module;
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error('Cannot find module "' + req + '".');
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0e05";